import { controls,grouped } from "../controls";
const td_schedule = {
label: "Term Deposit Schedules",
pageLabel: "Term Deposit Schedules",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:false} },
pageType: "history",
filter:[
]
,form:[
...controls.displayText({ tab: "general", label: "Term Deposit",star:false}),
...controls.oc({ tab: "general", c: "TermDeposit", placeHolder: "Term Deposit Code", name: "term_deposit_code", isRequired:false,fastpath:"term_deposits"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "term_deposit_display"}),
...controls.magicDateLabel({ tab: "general", label: "Interest Date",target: "interest_date",star:true}),
...controls.magicDate({ tab: "general", name: "interest_date", dateType: "ontype",isRequired:true }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Days",star:true}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "days",isRequired:true,maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Months",star:true}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "months",isRequired:true,maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Amount"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "amount",maxlength:18}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
]
,history:{
perPage: 10,
reportHeader: "Term Deposit Schedules",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
]}};
export default td_schedule;